import React from "react";
import { Link, useLocation } from "react-router-dom";

const Tab = ({
  label,
  to,
  activeColor = "text-primary-primary-500 border-primary-primary-500",
  inactiveColor = "text-neutrals-neutral-300 border-transparent",
}) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      className={`relative px-1 pb-3 text-sm text-neutrals-neutral-300 font-semibold border-solid border-b-2 transition-all duration-200 no-underline 
        ${
          isActive ? activeColor : inactiveColor
        } hover:text-neutrals-neutral-900`}
    >
      {label}
    </Link>
  );
};

export default Tab;
